import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';

import { MODAL_TYPES } from 'common/constants/common';
import {
  NEWS_READING_POSTPONED,
  startUnreadNewsCheckingInterval,
  stopUnreadNewsCheckingInterval,
} from 'affiliates/actions/news';
import { OVERVIEW_NEWS_PATH } from 'common/selectors/sidebar/common';
import { MAYBE_ENTITY_ID } from 'common/routes/constants';
import { isIncarnatedConfigSelector } from 'common/selectors/config';
import {
  getUnreadSelector,
  fetchUnreadNewsItemsSuccessAction,
} from 'common/reducers/news';
import { POSTPONED_NEWS_LS_KEY } from 'affiliates/constants/news';
import { SessionFeatures } from 'common/constants/ui';
import { loginSuccessAction, logoutSuccessAction } from 'users/reducers/auth';
import {
  addSidebarDangerAction,
  removeSidebarDangerAction,
} from 'common/reducers/sidebar';
import { showModalAction } from 'common/reducers/ui';

const getPostponedNewsIds = () =>
  (localStorage.getItem(POSTPONED_NEWS_LS_KEY) || '')
    .split(',')
    .map(parseFloat)
    .filter(Boolean);

const middleware = (store) => (next) => (action) => {
  const result = next(action);
  const { dispatch, getState } = store;
  const state = getState();

  switch (action.type) {
    case loginSuccessAction.type: {
      if (!isIncarnatedConfigSelector(state)) {
        dispatch(startUnreadNewsCheckingInterval());
      }
      break;
    }

    case logoutSuccessAction.type: {
      dispatch(stopUnreadNewsCheckingInterval());
      break;
    }

    case NEWS_READING_POSTPONED: {
      const unread = getUnreadSelector(state);
      const unreadWithAlert = unread.find(
        ({ expiredAt, withAlert }) =>
          withAlert &&
          (expiredAt === null ||
            differenceInCalendarDays(new Date(expiredAt), new Date()) >= 0),
      );

      if (unreadWithAlert) {
        localStorage.setItem(
          POSTPONED_NEWS_LS_KEY,
          [...getPostponedNewsIds(), unreadWithAlert.id].join(','),
        );
      }

      break;
    }

    case fetchUnreadNewsItemsSuccessAction.type: {
      const unread = getUnreadSelector(state);
      const unreadWithAlert = unread.find(
        ({ expiredAt, withAlert }) =>
          withAlert &&
          (expiredAt === null ||
            differenceInCalendarDays(new Date(expiredAt), new Date()) >= 0),
      );

      const sidebarAction =
        unread.length > 0 ? addSidebarDangerAction : removeSidebarDangerAction;

      dispatch(
        sidebarAction({
          path: `${OVERVIEW_NEWS_PATH}${MAYBE_ENTITY_ID}`,
          value: unread.length,
        }),
      );

      if (
        unreadWithAlert &&
        !getPostponedNewsIds().includes(unreadWithAlert.id) &&
        sessionStorage.getItem(
          `${SessionFeatures.HideNewsAlert}_${unreadWithAlert.id}`,
        ) !== 'true'
      ) {
        dispatch(
          showModalAction({
            modalName: MODAL_TYPES.NEWS_ALERT_MODAL,
            params: {
              ...unreadWithAlert,
            },
          }),
        );
      }

      break;
    }

    default:
      break;
  }

  return result;
};

export default middleware;
